import { ROUTE_KEYS } from './routeKeys';

const ROUTE_TITLES: Record<(typeof ROUTE_KEYS)[number], string> = {
    DROIT_IMAGE_PREVIEW: 'Aperçu',
    DROIT_IMAGE_ENTRIES: "Droits à l'image",
    DROIT_IMAGE_FORM: 'Droit à l’image',
    FICHE_RENSEIGNEMENT: 'Fiche de renseignements',
    FICHE_RENSEIGNEMENT_ENTRIES: 'Fiches de renseignements',
    FICHE_INSCRIPTION: "Formulaire d'inscription",
    FICHE_INSCRIPTION_ENTRIES: "Formulaires d'inscription",
    FICHE_INSCRIPTION_PREVIEW: "Récapitulatif formulaire d'inscription",
    FORMATION_CONTINUE: 'Formation continue',
    FORMATION_INITIALE: 'Formation initiale',
    FORMATION_ENTRY: 'Fiche de candidature',
    FORMATION_ENTRIES: 'Entrées',
    INSCRIPTION_SUCCESS: 'Inscription réussie',
    FORMATION_INITIALE_SUCCESS: 'Candidature envoyée',
    FICHE_RENSEIGNEMENT_SUCCESS: 'Fiche envoyée',
    FICHE_RENSEIGNEMENT_PREVIEW: 'Aperçu de la fiche',
};

export { ROUTE_TITLES };
